export default __webpack_public_path__ + "static/media/p2-homepage.bda74972.png";